import React, { useState, useEffect } from 'react'
import ResponseMsg from '../general/ResponseMsg';
import { useNavigate } from 'react-router-dom';

const StaffDashboard = ({ userData }) => {
  const [response, setResponse] = useState('');
  const [products, setProducts] = useState([]);
  const [visibleCount, setVisibleCount] = useState(50);
  const [searchQuery, setSearchQuery] = useState('');
const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch('https://api.kcmstore.in/store/get-product');
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id);
          setProducts(sortedProducts);
        } else {
          console.error('Failed to fetch products');
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchProducts();
  }, []);

  // search among products
  // const filteredProducts = products.filter(product =>
  //   product.name.toLowerCase().includes(searchQuery.toLowerCase())
  // );
const filteredProducts = products.filter(product => {
  const query = searchQuery.toLowerCase();

  const name = product.name?.toLowerCase() || "";
  const brand = product.brand?.toLowerCase() || "";
  const category = product.category?.toLowerCase() || "";
  const composition = product.composition?.toLowerCase() || "";

  return (
    name.includes(query) ||
    brand.includes(query) ||
    category.includes(query) ||
    composition.includes(query)
  );
});

  // add medicine to store
  // const handleAddMedicine = async (productId) => {

  //   console.log(userData);
  //   try {
  //     const response = await fetch('https://api.kcmstore.in/store/add-mymedicine', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         productId: productId,
  //         userId: userData.id,
  //       }),
  //     });

  //     const result = await response.json();

  //     if (response.ok) {
  //       setResponse("Medicine added to your store");
  //       setTimeout(() => setResponse(''), 2000);
  //     } else {
  //       setResponse(result.message || 'Something went wrong');
  //       setTimeout(() => setResponse(''), 2000);
  //     }
  //   } catch (error) {
  //     console.error('Error adding medicine:', error);
  //   }
  // };

  useEffect(() => {
    setVisibleCount(50);
  }, [searchQuery]);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleCount((prev) => {
        if (prev >= filteredProducts.length) {
          clearInterval(interval);
          return prev;
        }
        return prev + 50;
      });
    }, 4000);
  
    return () => clearInterval(interval);
  }, [filteredProducts]);
  
  

  return (
    <>
      <section className='py-4 bg-light'>
        <div className='px-4'>

          <div className='row'>


            <div className='col-lg-9 col-12 my-2'>

              <div className='d-lg-flex d-md-flex d-block justify-content-between'>
                <div className='d-flex'>
                  <p className='sec-heading'>Dashboard</p>
                  <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Sub Admin</span></div>

                <div className="text-start mb-4">
                  <input
                    type="text"
                    className="form-input w-auto rounded border-0"
                    placeholder="🎯 Search products..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
              </div>


              <div className='row bg-white rounded-4 px-lg-2 py-3 justify-content-start'>
                {filteredProducts.length > 0 ? (
                  filteredProducts.slice(0, visibleCount).map((product) => (
                    <div key={product.id} className='col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 my-2 px-2'>
                      <div className='featured-area h-100 align-content-center'>

                        <img src={`https://api.kcmstore.in/sUploads/${product.image.split(',')[0]}`} className='img-fluid' alt={product.name || 'Product'} />
                        <p className='featured-category'>{product.unit || 'Unit'}</p>
                        <p className='featured-name cursor-pointer'onClick={() => navigate(`/product-details/${product.name}`, { state: { product } })}>{product.name}</p>
                        <p className='featured-price d-flex justify-content-center'>₹ {product.sell_price}{product.discount_amount > 0 && (
                          <p className='text-start ps-2 text-muted fw-semibold fs-6 my-0'>
                            {product.discount_amount}{product.discount_type === 'percent' ? '%' : '₹'}  Off
                          </p>
                        )}</p>
                        {/* <button className='login-btn2 w-100 py-1' onClick={() => handleAddMedicine(product.id)}>Add +</button> */}
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No products available</p>
                )}
              </div>

            </div>
            {/* left section ends */}


            <div className='col-lg-3 col-12 my-2 px-lg-3 px-md-3 px-0'>
              <div className='bg-white px-3 py-3 rounded-3'>
                <p className='fw-semibold'>Recently Added</p>

                {products.length > 0 ? (
                  products.slice(0, 4).map((product) => (
                    <>
                      <hr />
                      <div key={product.id} className='d-flex my-2'>

                        <img src={`https://api.kcmstore.in/sUploads/${product.image.split(',')[0]}`} className='img-fluid col-3 me-3' alt={product.name || 'Product'} />

                        <div>
                          <p className='featured-name'>{product.name}</p>
                          <p className='featured-category'>{product.unit || 'Unit'}<br />₹ {product.sell_price}</p></div>
                      </div>
                    </>
                  ))
                ) : (
                  <p>No products available</p>
                )}

              </div>
              {/* recently added ends */}


              {/* bottom banner section */}
              <section className='bottom-banner-bg my-3 rounded-4'>
                <div className='container py-5'>

                  <p className='fw-bold'>Doctor's Recommended Range</p>
                  <button className='banner-btn animate__animated animate__pulse animate__infinite' onClick={() => navigate('/my-medicine')}>My Store</button>

                </div>
              </section>
              {/* bottom banner section ends */}

            </div>
            {/* right section ends */}



          </div>
          {/* row ends */}

        </div>
      </section>


      {response && <ResponseMsg message={response} />}
    </>
  )
}


export default StaffDashboard
